module.exports = __webpack_public_path__ + "static/img/AxialCaldera-RA.37d35b4.png";